import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagMostrarRazonSocialFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagMostrarRazonSocial'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagMostrarRazonSocial'
          label='Mostrar Razon Social'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagMostrarRazonSocialFormGroup)
